var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 1.28516V24.0567","stroke":"white","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M2 14.741L11 24.0566L20 14.741","stroke":"white","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":1})]);
}

ArrowDown.defaultProps = {"width":"22","height":"26","viewBox":"0 0 22 26","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
